import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import { instagram } from '../../../assets'
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { Modal, Typography, Button, Accordion, CircularProgress, IconButton, Divider } from '@mui/material';
import AppDetailSkeleton from '../../skeleton/AppDetailSkeleton';
import { POSTINSTALLAPP2, POSTPERMISSION, POSTPERMISSIONAPPROVAL } from '../../services/seller/endpoint';
import { useSelector } from 'react-redux';
import SyncIcon from '@mui/icons-material/Sync';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { warningIcon, warningError } from "../../../assets"
import { vectorIcon } from "../../../assets"
import { ToastContainer, toast } from 'react-toastify';
import { captureGAEvent, gaPanelConfig } from '../../shared/helper';
import { clearEvents } from '../../utils/changeHeaderColor';


interface Permission {
  id: string;
  name: string;
  description: string;
  access: string;
}

interface ModuleData {
  permission_id: string;
  module: string;
  list_of_permissions: Permission[];
  reason: string;
}

const InstallPopup = ({ open, onClose, appData, viewType }) => {
  const [expanded, setExpanded] = useState<any>({});
  const [data, setData] = useState<ModuleData[]>([]);
  const auth = useSelector((state: any) => state.auth);
  const [isInstallLoading, setInstallLoading] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [expandedPanel, setExpandedPanel] = useState(null);
  const isPermission = localStorage.getItem("permission") === "true";

  useEffect(() => {

    if (isPermission) {
      fetchData();
    }
  }, [isPermission]);


  const fetchData = async () => {
    setLoading(true)
    console.log("permission API call");
    try {
      const response = await fetch(POSTPERMISSION(appData.app_id), {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${auth.token}`,
        },

      });

      if (!response.ok) {
        toast.error("Somthing went wrong")
        throw new Error('Network response was not ok');
      }

      const jsonData: { data: ModuleData[] } = await response.json();
      setData(jsonData.data);
    } catch (error: any) {

      console.error('Error fetching data:', error);
    }
    finally {
      setLoading(false)
      localStorage.setItem("permission", "false");
    }
  };

  const submitPermissionApproval = async (appId) => {
    const apiUrl = POSTPERMISSIONAPPROVAL();

    const requestData = {
      app_id: appId,
    };
    setInstallLoading(true);

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.token}`,
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();


      // Handle the response data as needed

    } catch (error) {
      console.error('Error making API request:', error);
      // Handle errors
    } finally {
      // Set isReviewLoading back to false after the API call is complete
      setInstallLoading(false);
    }
  };

  const installApp2 = async (app_id) => {
    const apiUrl = POSTINSTALLAPP2();

    const requestData = {
      app_id: app_id,
    };
    setInstallLoading(true);
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.token}`,
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const jsonData = await response.json();
      const redirectUrl = jsonData.data.redirect_url;
      window.open(redirectUrl, '_blank');
      // Handle the response data as needed

    } catch (error) {
      console.error('Error installing app:', error);
    } finally {
      // Set isReviewLoading back to false after the API call is complete
      setInstallLoading(false);
    }
  };

  const handleInstall = async () => {
    clearEvents()
    gaPanelConfig.AppID = appData!.app_id;
    gaPanelConfig.AppSlug = appData!.slug;
    gaPanelConfig.DeveloperID = appData!.developer_id;
    gaPanelConfig.AppName = appData!.app_name;
    gaPanelConfig.BtnText = appData!.status;
    captureGAEvent("sras_permission_install_button_click", "sras_permission_install_button_click");

    if (appData.status === 'Not Supported') {
      submitPermissionApproval(appData.app_id);
    } else {
      await installApp2(appData.app_id);
      // fetchData();

      //  // Fetch permission data after installation
    }
    onClose();
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : null);
  };

  if (!data) {
    return <AppDetailSkeleton />;
  }

  return (
    <>
      <Modal open={open} onClose={onClose} >
        <>
          {/* <ToastContainer /> */}
          <div style={{ position: 'absolute', top: '50%', left: '50%', width: viewType === "tab" ? "400px" : ("640px"), transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '20px', outline: 'none', borderRadius: '10px' }}>

            <IconButton style={{ marginTop: "10px", position: 'absolute', top: '20px', right: '20px' }} onClick={onClose}>
              <CloseIcon />
            </IconButton>

            <div style={{ marginTop: "20px", }}>
              <span style={{ padding: '20px', fontFamily: 'sfprobold', lineHeight: '24px', }}>
                <strong style={{ fontSize: '24px', fontFamily: "sfprobold", fontWeight: 'bold', lineHeight: '24px' }}>
                  {"You are about to install "}
                </strong>
              </span>
            </div>
            <div style={{ paddingTop: "30px", height: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ display: 'flex', backgroundColor: 'white', alignItems: 'center' }}>
                <img src={process.env.PUBLIC_URL + "/favicon.svg"} style={{ height: '44px', width: '44px', marginRight: "40px" }} alt="Favicon" />
                <img src={vectorIcon} style={{ width: "25px", }} alt="Warning Icon" />
                <img src={appData.app_icon} style={{ height: '44px', width: '44px', marginLeft: "40px" }} alt="App Icon" />

              </div>
            </div>


            <div style={{ paddingTop: "30px", padding: '20px' }}>
              < Divider />
            </div>

            {isLoading ? (
              <div style={{ marginTop: "10px", textAlign: "center" }}>
                <CircularProgress color="inherit" size={40} />
              </div>
            ) : (
              <div style={{ marginBottom: '20px', paddingLeft: '20px', paddingRight: '20px', borderRadius: '10px' }}>
                <span style={{ fontSize: '20px', fontWeight: 'bold', fontFamily: "sfpromedium" }}>
                  <strong style={{ fontFamily: "sfprobold" }}>{appData.app_name + " will be able to:"}</strong>
                </span>
                <div style={{ height: 'auto',maxHeight:"300px", overflowY: 'auto' }}>
                  {data !== null ? (
                    Array.isArray(data) ? (
                      data.map((moduleData, index) => (
                        <div style={{ marginTop: "10px", boxShadow: "none" }} key={moduleData.permission_id}>
                          <Accordion style={{ boxShadow: "none" }} expanded={expandedPanel === `panel${index}`} onChange={handleChange(`panel${index}`)}>
                            <AccordionSummary
                              aria-controls={`panel${index}bh-content`}
                              id={`panel${index}bh-header`}>
                              <div style={{ fontSize: '18px', fontWeight: 'bold', fontFamily: "sfpromedium", lineHeight: '24px' }}>
                                {moduleData.module}
                              </div>
                              <div style={{ position: 'absolute', right: '16px' }}>
                                {expandedPanel === `panel${index}` ? (
                                  <Typography style={{ color: "#735AE5", fontSize: "16px", fontFamily: "sfpromedium" }} variant="caption">Hide details</Typography>
                                ) : (
                                  <Typography style={{ color: "#735AE5", fontSize: "16px", fontFamily: "sfpromedium" }} variant="caption">View details</Typography>
                                )}
                              </div>
                            </AccordionSummary>

                            {expandedPanel === `panel${index}` && (
                              <div>
                                <AccordionDetails style={{ fontSize: "16px", fontFamily: "sfpromedium" }}>
                                  <div style={{ background: "#F9FAFB", borderRadius: "10px" }}>
                                    <ul style={{ padding: "10px" }}>
                                      {moduleData.list_of_permissions.map((permission) => (
                                        <li style={{ fontSize: '14px', fontWeight: "500" }} key={permission.id}>
                                          <strong style={{ fontWeight: 'bold', fontSize: '14px', lineHeight: '24px', fontFamily: "sfprobold" }}>{permission.name}</strong>
                                          <br />
                                          <div>
                                            <span style={{ color: "#939393", lineHeight: '24px', fontSize: '14px', fontWeight: "400" }}>{permission.description + " (" + permission.access + ")"}</span>
                                          </div>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  <div style={{ paddingLeft: "2px", marginTop: "10px", display: "flex", alignItems: "center", background: "fff" }}>
                                    <div style={{ border: "none", borderRadius: "none" }}>
                                      <img style={{ width: "15px" }} src={warningError} alt="Warning Icon" />
                                    </div>
                                    <div style={{ fontSize: "16px", fontFamily: "sfproregular", color: "#475467", paddingLeft: "5px" }}>{moduleData.reason}</div>
                                  </div>
                                </AccordionDetails>
                              </div>
                            )}
                          </Accordion>
                          {index !== data.length - 1 && <div />}
                        </div>
                      ))
                    ) : (
                      <p style={{ fontFamily: "sfpronormal" }}>Invalid data format: {JSON.stringify(data)}</p>
                    )
                  ) : (
                    <p>No data</p>
                  )}
                </div>
                <div style={{ marginTop: "10px", backgroundColor: "#FFFCEB", padding: "10px", display: "flex", alignItems: "center" }}>
                  <div style={{ border: "none", borderRadius: "none", paddingBottom: "12px" }}>
                    <img style={{ width: "25px" }} src={warningIcon} alt="Feature Icon" />
                  </div>
                  <div style={{ fontSize: "14px", fontFamily: "sfpromedium", paddingLeft: "10px" }}>
                    {"Shiprocket has reviewed " + appData.app_name + " and verified that it needs access to all past and future orders to provide value to you."}
                  </div>
                </div>
              </div>

            )}

            {/* button */}
            <div style={{ padding: '10px', fontSize: "16px", fontFamily: "sfpronormal", display: "flex", justifyContent: "flex-end" }}>
              <div style={{ fontSize: "16px", fontFamily: "sfpronormal", marginTop: '10px' }}>
                <Button onClick={onClose} variant="outlined" style={{ marginRight: '10px', color: "#735AE5", outlineColor: "#735AE5", borderColor: "#735AE5" }}>
                  Cancel
                </Button>
                <Button
                  onClick={handleInstall}
                  variant="contained"
                  style={{ color: "white", background: "#735AE5" }}
                  className={isInstallLoading ? 'loader-class' : ''}
                  disabled={isInstallLoading}>
                  {isInstallLoading ? <CircularProgress color="inherit" size={40} /> : (appData.status === 'Not Supported' ? 'Submit Approval' : 'Install')}
                </Button>
              </div>
            </div>
          </div>
        </>

      </Modal>
    </>
  );
};

// Define PropTypes for the component
InstallPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  viewType: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  appData: PropTypes.shape({
    status: PropTypes.string.isRequired,
    app_id: PropTypes.string.isRequired,
    app_name: PropTypes.string.isRequired,
    app_icon: PropTypes.string.isRequired,
    app_type: PropTypes.string.isRequired,

    // Add other required properties here
  }).isRequired,
};


export default InstallPopup;